export enum ProfessionalSpeciality {
  NEUROLOGIST = 'neurologist',
  PHYSIOTHERAPIST = 'physiotherapist',
  PRATICAL_NURSE = 'practical_nurse',
  MIDWIFE = 'midwife',
  CARDIOLOGIST = 'cardiologist',
  GENERAL_PRACTITIONER = 'general_practitioner',
  PSYCHOLOGIST = 'psychologist',
  OCCUPATIONAL_THERAPIST = 'occupational_therapist',
  PSYCHOMOTOR_THERAPIST = 'psychomotor_therapist',
  REHABILITATION_DOCTOR = 'rehabilitation_doctor',
}

export const professionalSpecialityMapping = {
  [ProfessionalSpeciality.NEUROLOGIST]: $localize`:@@common_professionalSpeciality_neurologist:Neurologist`,
  [ProfessionalSpeciality.PHYSIOTHERAPIST]: $localize`:@@common_professionalSpeciality_physiotherapist:Physiotherapist`,
  [ProfessionalSpeciality.PRATICAL_NURSE]: $localize`:@@common_professionalSpeciality_praticalNurse:Pratical nurse`,
  [ProfessionalSpeciality.MIDWIFE]: $localize`:@@common_professionalSpeciality_midwife:Midwife`,
  [ProfessionalSpeciality.CARDIOLOGIST]: $localize`:@@common_professionalSpeciality_cardiologist:Cardiologist`,
  [ProfessionalSpeciality.GENERAL_PRACTITIONER]: $localize`:@@common_professionalSpeciality_generalPractitioner:General practitioner`,
  [ProfessionalSpeciality.PSYCHOLOGIST]: $localize`:@@common_professionalSpeciality_psychologist:Psychologist`,
  [ProfessionalSpeciality.OCCUPATIONAL_THERAPIST]: $localize`:@@common_professionalSpeciality_occupationalTherapist:Occupational therapist`,
  [ProfessionalSpeciality.PSYCHOMOTOR_THERAPIST]: $localize`:@@common_professionalSpeciality_psychomotorTherapist:Psychomotor therapist`,
  [ProfessionalSpeciality.REHABILITATION_DOCTOR]: $localize`:@@common_professionalSpeciality_rehabilitationDoctor:Rehabilitation doctor`,
};
